import { render, staticRenderFns } from "./residentDelete.vue?vue&type=template&id=53d97210&scoped=true&"
import script from "./residentDelete.vue?vue&type=script&lang=js&"
export * from "./residentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d97210",
  null
  
)

export default component.exports